import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IObject } from '../../../../type_definitions/datatypes';
import { UntypedFormGroup } from '@angular/forms';
import { IExtraFieldConfigurationObject } from '../../formly/ga-formly.service';
import { GaValidateService } from '../../formly/ga-validate.service';
import { IReportAction } from '../report-data.service';
import { Subscription } from 'rxjs';
import { GaEventService, IGAEvent } from '../../services/ga-event.service';
import { BUTTON_SAVE, DefaultFormDialogComponent } from '../../message/dialogs/default-form-dialog.component';
import { Override } from '../../app-decorators';
import { IDialogButton } from '../../message/ga-message.service';
import * as _ from 'underscore';
import { EVENT_REPORT_ACTION_DONE } from '../../app-events';

@Component({
  selector: 'base-report-actions-dialog',
  template: ''
})
export abstract class BaseReportActionsDialog extends DefaultFormDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
   * @description Extra action dialog params
   */
  @Input() public actionDialogParams?: IObject;
  /**
   * @description Row selection in report grid, array of selected report rows
   * @summary Array of selected report rows
   */
  @Input() public rowSelection: IObject[];
  /**
   * @description Current report id
   */
  @Input() public reportId: number;
  /**
   * @description Selected report action
   */
  @Input() public action: IReportAction;

  public loading: boolean;
  public executing: boolean;
  public form: UntypedFormGroup = new UntypedFormGroup({});
  public fields: IExtraFieldConfigurationObject[] = [];
  public model: IObject = {};

  private eventHandler: Subscription;
  protected saveButtonLabel: string;

  protected constructor(
    private eventService: GaEventService,
    validateService: GaValidateService
  ) {
    super(validateService);
  }

  @Override(DefaultFormDialogComponent)
  public ngOnInit(): void {
    this.buttons = [{
      id: BUTTON_SAVE,
      label: this.saveButtonLabel || this.title,
      className: 'btn btn-success',
      onClick: () => this.execute(),
      busy: this.executing,
      disabled: this.executing || !!this.error || this.loading
    }, {
      label: 'GA.BUTTONS.CANCEL',
      className: 'btn btn-danger',
      onClick: () => this.onCancel.emit()
    }];
  }

  public ngAfterViewInit(): void {
    this.eventHandler = this.eventService.events.subscribe((evt: IGAEvent) => {
      if (evt.name === EVENT_REPORT_ACTION_DONE) {
        // this will only be triggered when report action is executed
        this.updateButtonStatus(false);
      }
    });
  }

  public ngOnDestroy(): void {
    this.eventHandler?.unsubscribe();
  }

  public validate(prependExtraErrors?:string[]): Promise<string[] | void> {
    return this.validateService.validateFields(this.fields, this.model, true, prependExtraErrors);
  }

  public execute(): void {
    this.updateButtonStatus(true);

    this.validate()
      .then(() => {
        this.onSave.emit(this.getModel());
      })
      .catch(() => {
        this.updateButtonStatus(false);
      });
  }

  protected updateButtonStatus(isExecuting?: boolean, isDisabled?: boolean):void {
    if (!_.isUndefined(isExecuting)) {
      this.executing = isExecuting;
    }

    const button:IDialogButton = _.find(this.buttons, { id: BUTTON_SAVE });
    if (button) {
      button.busy = this.executing;
      button.disabled = (!_.isUndefined(isDisabled) && isDisabled) || this.executing || !!this.error || this.loading;
    }
  }
}